import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, ITelemetryPlugin } from '@microsoft/applicationinsights-web';
import { getEnv } from '../helper/get-env';

const reactPlugin = new ReactPlugin();
const appInsights = async () => {
    return new ApplicationInsights({
        config: {
            connectionString: await getEnv('APP_INSIGHTS_CS'),
            enableAutoRouteTracking: false,
            autoTrackPageVisitTime: false,
            extensions: [reactPlugin as unknown as ITelemetryPlugin]
        }
    });
};

export default await appInsights();
export { reactPlugin };
